import { useState } from "react";
import { NavLink } from "react-router-dom";
import { BsLayoutSidebar } from "react-icons/bs";
import { MdOutlineDashboard } from "react-icons/md";
import { CONST } from "../../../../../_config";
import { IoChevronForward, IoClose, IoSearch, } from "react-icons/io5";
import { HiOutlineUsers } from "react-icons/hi";
import { TbEdit, TbReportAnalytics } from "react-icons/tb";

export default function SidebarUser(props) {

  let { empList: empXList, selectTeamEmp, memberName: memberXName, crrEmpId, isNewChat, collapsed, setCollapsed, getChatBookmarkData, selectChatBookMark, chatMarkIdInit, pageName, switchToAdmin } = props;

  const empList = empXList && empXList.length > 0 ? empXList.map(ele => ({
    ...ele,
    name: (ele.name || "").trim().split(/\s+/)[0]
  })) : [];
  const memberName = (memberXName || "").trim().split(/\s+/)[0]



  function getActive(path) {
    const currentPath = window.location.hash.replace(/^#/, "");
    return currentPath === path;
  }

  const [openMemberModal, setOpenMemberModal] = useState(false);
  const [search, setSearch] = useState("");

  const isMobile = window.innerWidth <= 700;


  const menu = [
    {
      name: "Overview",
      path: "/assessment/coachteams",
      isActive: getActive("/assessment/coachteams"),
      icon: <MdOutlineDashboard className="w-5 h-5" />,
    },
    // {
    //   name: "Team Report",
    //   path: "/assessment/myteamreport",
    //   isActive: false,
    //   icon: <TbReportAnalytics className="w-5 h-5" />,
    // },
    // {
    //   name: "Avira For Self",
    //   path: "/assessment/mychatbot",
    //   isActive: false,
    //   icon: <span class="material-symbols-outlined text-[1.5rem] ">
    //     auto_awesome
    //   </span>
    // }

  ];

  const menuIndividual = [
    {
      name: "Avira For Coach",
      path: "/assessment/coachteams",
      isActive: true,
      icon: <span class="material-symbols-outlined text-[1.5rem] text-white">
        auto_awesome
      </span>
    }
  ];


  let chathistoryList =
    getChatBookmarkData && getChatBookmarkData.length > 0
      ? getChatBookmarkData
      : [];

  const chatMenu = [
    { name: "New Chat", chatMarkId: "new" },
    ...chathistoryList.map((ele) => ({ name: ele.question, chatMarkId: ele.id }))
  ];


  const filteredEmployees = empList && empList.length > 0 ? empList.filter((emp) => emp.name.toLowerCase().includes(search.toLowerCase())) : [];

  return (
    <>
      {/* SIDEBAR */}
      <aside
        className={`fixed top-0 left-0 z-50 h-screen overflow-hidden overflow-y-auto pb-2 bg-[#f9fafb] border-r transition-all duration-300 ease-in-out flex flex-col ${collapsed ? "md:w-20" : "md:w-64"}  md:translate-x-0 w-64 ${collapsed ? "-translate-x-full" : "translate-x-0"}`}>
        {/* HEADER */}
        <div className="px-4 py-5 flex items-center bg-[#f9fafb] justify-between sticky top-0">
          {!collapsed && (
            <img src={CONST.IMAGES_URL + "TalentPlusStrengths_logo.svg"} alt="logo" className="w-32" />
          )}
          <button onClick={() => setCollapsed(!collapsed)} className="hidden md:flex p-2 rounded-lg hover:bg-gray-200">
            <BsLayoutSidebar className="w-5 h-5" />
          </button>
        </div>

        {/* MENU */}
        <nav className="px-2 space-y-1">
          {menu.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setCollapsed(item.name === "AI Assistant" ? false : true)}
              className={({ }) =>
                `group flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition  
              ${item.isActive
                  ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                  : "hover:bg-gray-200 hover:text-black"
                }`
              }
            >
              {item.icon}
              {!collapsed && item.name}
            </NavLink>
          ))}
        </nav>

        <div className="mt-4" />

        <nav className="px-2 space-y-2">
          {menuIndividual.map((item) => (
            <>
              <NavLink key={item.name} to={item.path}
                onClick={() => setCollapsed(item.name === "AI Assistant" ? false : true)}
                className={({ }) => `group flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition 
                    ${item.isActive
                    ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                    : "hover:bg-gray-200 hover:text-black text-black"
                  }`}>
                {item.icon}
                {!collapsed && item.name}
              </NavLink >

              {memberName &&
                <>
                  <div className="group flex items-center justify-between px-3 py-3 rounded-lg cursor-pointer bg-gradient-to-r from-[#EFF6FF] to-[#DBEAFE] border border-blue-300 hover:shadow-md transition-all duration-200">
                    <div className="space-y-2">
                      <div onClick={() => { setCollapsed(isMobile ? !collapsed : collapsed); setOpenMemberModal(true); }} className="flex items-center gap-3 min-w-0">
                        <div className="w-8 h-8 rounded-full bg-[#1976D2] text-white flex items-center justify-center text-xs font-semibold">{memberName?.charAt(0)?.toUpperCase()}</div>
                        <span className="text-sm font-medium text-gray-800 truncate">{!collapsed && memberName}</span>
                      </div>
                      {!collapsed &&
                        <button onClick={() => { setCollapsed(isMobile ? !collapsed : collapsed); setOpenMemberModal(true); }} className={`flex items-center gap-2 border border-[#1976D2] rounded-md px-2 py-2 text-[#1976D2] font-medium transition-all duration-300 ${!collapsed && "ml-8"}`}>
                          <HiOutlineUsers size={16} />
                          {!collapsed && <span className="text-xs whitespace-nowrap">Change Member</span>}
                          {!collapsed && <IoChevronForward size={16} />}
                        </button>}

                    </div>
                  </div>
                </>
              }

              {pageName === ("/assessment/myteamchatbot") && !collapsed ?
                chatMenu.map((item, index) => (
                  (item && item.name) &&
                  <div key={index} onClick={() => { setCollapsed(isMobile ? !collapsed : collapsed); selectChatBookMark(item.chatMarkId); }}
                    className={` group flex items-center px-3 py-2.5 rounded-md cursor-pointer transition-colors duration-200
                        ${isNewChat ? true : (item.chatMarkId === chatMarkIdInit)
                        ? "bg-gray-200 text-gray-900"
                        : "text-gray-700 hover:bg-gray-200"
                      }`}>
                    {!collapsed && (
                      <div className="ml-2 flex  space-x-3 w-52">
                        {item.name === "New Chat" && <TbEdit size={18} />}
                        <span className=" text-sm leading-snug truncate group-hover:text-gray-900 overflow-hidden" title={item.name}>{item.name}</span>
                      </div>
                    )}
                  </div>
                )) : null}
            </>
          ))}

        </nav>
      </aside>

      {/* MOBILE OVERLAY */}
      {
        !collapsed && (
          <div
            className="fixed inset-0 bg-black/40 z-40 md:hidden"
            onClick={() => setCollapsed(true)}
          />
        )
      }

      {
        isMobile ?
          <>
            {/* Mobile design Model */}
            {openMemberModal && (
              <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">
                  <div className="flex justify-between items-center px-6 py-2 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">Select Team Member</h2>
                    <button onClick={() => setOpenMemberModal(false)} className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center">
                      <IoClose size={28} />
                    </button>
                  </div>
                  <div className="p-4">
                    <div className="relative">
                      <IoSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={22} />
                      <input type="text" placeholder="Search team member..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full border border-gray-300   rounded-md pl-12 pr-4 py-2.5 outline-none focus:border-blue-500" />
                    </div>
                  </div>
                  <div className="max-h-[400px] overflow-y-auto">
                    {filteredEmployees && filteredEmployees.length > 0 ?
                      filteredEmployees.map((item) => (
                        <div key={item.emp_id} onClick={() => { setOpenMemberModal(false); selectTeamEmp(item.emp_id); }}
                          className="flex items-center justify-between px-6 py-2 border-b hover:bg-blue-50 cursor-pointer transition">
                          <div className="flex items-center gap-4">
                            <div className="w-8 h-8 rounded-full bg-blue-100 text-[#1976D2] font-medium text-base flex items-center justify-center">
                              {item.name.split(" ").map((word) => word[0]).slice(0, 2).join("")}
                            </div>
                            <span className="text-sm font-medium text-gray-800">{item.name}</span>
                          </div>
                          <IoChevronForward size={22} className="text-gray-500" />
                        </div>
                      )) : []}
                  </div>
                </div>
              </div>
            )}
          </> :
          <>
            {/* Desktop design Model */}
            {openMemberModal && (
              <div className={`fixed inset-0 z-[999] flex items-center left-20 ${collapsed ? "!left-20" : "!left-64"}`}>
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">
                  <div className="flex justify-between items-center px-6 py-2 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">Select Team Member</h2>
                    <button onClick={() => setOpenMemberModal(false)} className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center">
                      <IoClose size={28} />
                    </button>
                  </div>
                  <div className="p-4">
                    <div className="relative">
                      <IoSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={22} />
                      <input type="text" placeholder="Search team member..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full border border-gray-300   rounded-md pl-12 pr-4 py-2.5 outline-none focus:border-blue-500" />
                    </div>
                  </div>
                  <div className="max-h-[400px] overflow-y-auto">

                    <div key={"overall"} onClick={() => { setOpenMemberModal(false); selectTeamEmp("overall"); }}
                      className="flex items-center justify-between px-6 py-2 border-b hover:bg-blue-50 cursor-pointer transition">
                      <div className="flex items-center gap-4">
                        <div className="w-8 h-8 rounded-full bg-blue-100 text-[#1976D2] font-bold text-base flex items-center justify-center">
                          {"OT"}
                        </div>
                        <span className="text-sm font-bold text-gray-800">{"Overall Team"}</span>
                      </div>
                      <IoChevronForward size={22} className="text-gray-500" />
                    </div>

                    {filteredEmployees && filteredEmployees.length > 0 ?
                      filteredEmployees.map((item) => (
                        <div key={item.emp_id} onClick={() => { setOpenMemberModal(false); selectTeamEmp(item.emp_id); }}
                          className="flex items-center justify-between px-6 py-2 border-b hover:bg-blue-50 cursor-pointer transition">
                          <div className="flex items-center gap-4">
                            <div className="w-8 h-8 rounded-full bg-blue-100 text-[#1976D2] font-medium text-base flex items-center justify-center">
                              {item.name.split(" ").map((word) => word[0]).slice(0, 2).join("")}
                            </div>
                            <span className="text-sm font-medium text-gray-800">{item.name}</span>
                          </div>
                          <IoChevronForward size={22} className="text-gray-500" />
                        </div>
                      )) : []}
                  </div>
                </div>
              </div>
            )}
          </>
      }

    </>
  );
}